<app-header [isLoggedIn]="apiService.isLoggedIn()" [userProfile]="apiService.profile()"></app-header>
<div class="minh">
<router-outlet />
</div>

<app-footer></app-footer>

@if(isLoaderShow()){
    <div class="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center loading-overlay">
        <div class="spinner-border loader" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
}

